import * as React from 'react';

import CourseraPlusWelcomeNotification from 'bundles/coursera-plus/components/lihp/CourseraPlusWelcomeNotification';
import S12nToCourseraPlusUpgradeNotification from 'bundles/coursera-plus/components/lihp/S12nToCourseraPlusUpgradeNotification';
import CourseraPlusMonthlyToAnnualUpgradeNotification from 'bundles/coursera-plus/components/monthlyToAnnualUpgrade/CourseraPlusMonthlyToAnnualUpgradeNotification';
import {
  getShouldSeeUpgradeSuccessNotification,
  removeShouldSeeUpgradeSuccessNotification,
} from 'bundles/coursera-plus/utils/useNotificationBannersHandler';

const CourseraPlusNotificationsContainer = () => {
  const [showS12nUpgradeNotification, setShowS12nUpgradeNotification] = React.useState(false);

  React.useEffect(() => {
    const shouldSeeUpgradeSuccessNotification = getShouldSeeUpgradeSuccessNotification();
    if (Boolean(shouldSeeUpgradeSuccessNotification)) {
      setShowS12nUpgradeNotification(true);
      removeShouldSeeUpgradeSuccessNotification();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showS12nUpgradeNotification && <S12nToCourseraPlusUpgradeNotification />}
      {!showS12nUpgradeNotification && <CourseraPlusMonthlyToAnnualUpgradeNotification />}
      <CourseraPlusWelcomeNotification />
    </>
  );
};

export default CourseraPlusNotificationsContainer;
